import { parsePhoneNumberFromString } from "libphonenumber-js";

/**
 * Formats an E.164 phone number string to its national format.
 * Returns the original string if parsing fails.
 */
export function formatPhoneNumber(e164: string): string {
	return parsePhoneNumberFromString(e164)?.formatNational() ?? e164;
}
